module.exports = __webpack_public_path__ + "img/keder_anthrazitgrau_ral7016.943620d1.jpg";